import { render, staticRenderFns } from "./points-address-oper.vue?vue&type=template&id=14ef1f3e&"
import script from "./points-address-oper.vue?vue&type=script&lang=js&"
export * from "./points-address-oper.vue?vue&type=script&lang=js&"
import style0 from "./points-address-oper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports